import React from 'react'
import { TextField } from 'office-ui-fabric-react'

export function MinimalImaForm({
  integrationTypeConfig,
  onIntegrationTypeConfigChange,
  disabled,
  errorCode,
}: {
  integrationTypeConfig: any
  onIntegrationTypeConfigChange: (config: any) => void
  disabled: boolean
  errorCode: string
}) {
  return (
    <>
      <TextField
        label="Parent Selector"
        placeholder="#caroda"
        errorMessage={errorCode === 'invalidSelector' ? 'Invalid selector' : ''}
        value={integrationTypeConfig.selector || ''}
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            selector: newValue || '',
          })
        }}
      />
      <TextField
        label="Custom CSS"
        placeholder=".carodaContainer { float: none; }"
        value={integrationTypeConfig.additionalStyles || ''}
        autoComplete="off"
        readOnly={false}
        disabled={disabled}
        multiline={true}
        rows={5}
        onChange={(
          _event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
          newValue?: string
        ): void => {
          onIntegrationTypeConfigChange({
            ...integrationTypeConfig,
            additionalStyles: newValue || '',
          })
        }}
      />
    </>
  )
}
